import React, { PureComponent } from 'react';
import { Field, FieldArray } from 'redux-form';
import { Editor, Image } from '../index';


const renderField = ({ input, label, type, meta: { touched, error } }) => (
  <div className="form-group">
    <label>{label}</label>
    <div>
      <input className="form-control" {...input} type={type} placeholder={label}/>
      {touched && error && <span>{error}</span>}
    </div>
  </div>
);


const renderArticles = ({ fields, meta: { error, submitFailed } }) => {
  return (
    <div className="planet-events__persons">
      <div className="planet-events__header">
        <h3>Articles</h3>
        <button className="btn btn-primary" type="button" onClick={() => fields.push({})}>Add</button>
        {submitFailed && error && <span>{error}</span>}
      </div>
      <div className="row">
        {fields.map((member, index) => (
          <div className="col-md-6 col-xs-12" key={index}>
            <div className="planet-events__member" key={index}>

              <div className="planet-events__header">
                <h4>Article #{index + 1}</h4>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => fields.remove(index)}>Remove
                </button>
              </div>

              <div className="planet-events__member-container-image">
                <div className="planet-events__member-image">
                  <Field
                    name={`${member}.imageUrl`}
                    component={Image}/>
                </div>
              </div>

              <Field
                name={`${member}.title`}
                type="text"
                component={renderField}
                label="Title"/>

              <div className="planet-events__member--info">
                <label>Info</label>
                <Field
                  name={`${member}.info`}
                  component={Editor}/>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const renderNews = ({ fields, meta: { error, submitFailed } }) => {
  return (
    <div className="planet-events__generics">
      <div className="planet-events__header">
        <h3>Events</h3>
        <button className="btn btn-primary" type="button" onClick={() => fields.push({})}>Add</button>
        {submitFailed && error && <span>{error}</span>}
      </div>
      <div className="row">
        {fields.map((member, index) => (
          <div className="col-md-6 col-xs-12" key={index}>
            <div className="planet-events__generic-member" key={index}>

              <div className="planet-events__header">
                <h4>Event #{index + 1}</h4>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => fields.remove(index)}>Remove
                </button>
              </div>

              <Field
                name={`${member}.title`}
                type="text"
                component={renderField}
                label="Title"/>

              <Field
                name={`${member}.sub_title`}
                type="text"
                component={renderField}
                label="Sub title"/>

              <Field
                name={`${member}.date_of_realization`}
                type="text"
                component={renderField}
                label="Date Of Realization"/>

              <Field
                name={`${member}.body`}
                component={Editor}
                label="Body"/>

            </div>
          </div>
        ))}
      </div>
    </div>
  );
};


class News extends PureComponent {

  render() {
    return (
      <div className="planet-events">
        <FieldArray name="news" component={renderNews}/>
        <hr/>
        <FieldArray name="articles" component={renderArticles}/>
      </div>
    );
  }
}

News.propTypes = {};
News.defaultProps = {};

export default News;



// WEBPACK FOOTER //
// ./src/components/news/index.js